export enum UserReportReasonType {
    // Problemi sa ponašanjem korisnika
    DontShowUp,            // Nije se pojavio u lokalu
    FakeOrder,             // Lažna porudžbina
    SpamOrders,            // Previše narudžbina (spam)

    // Problemi sa plaćanjem
    RefusedToPay,          // Odbio da plati
    PaymentIssue,          // Problem sa plaćanjem

    // Zloupotreba sistema
    AbuseOfSystem,         // Zloupotreba aplikacije (npr. rezervacije bez namere)
    MultipleAccounts,      // Više naloga (fake account abuse)

    // Neprimereno ponašanje
    InappropriateBehavior, // Neprimereno ponašanje u lokalu
    OffensiveLanguage,     // Uvredljiv govor
    Harassment,            // Uznemiravanje

    // Tehnički / ostalo
    IncorrectInformation,  // Netačni podaci (ime, telefon...)
    SuspiciousActivity,    // Sumnjivo ponašanje

    Other                  // Ostalo (uz opis)
}

export function getUserReportReasonTypeToString(reason: UserReportReasonType): string {
    switch (reason) {
        case UserReportReasonType.DontShowUp:
            return "Nije se pojavio u lokalu";
        case UserReportReasonType.FakeOrder:
            return "Lažna porudžbina";
        case UserReportReasonType.SpamOrders:
            return "Previše narudžbina (spam)";
        case UserReportReasonType.RefusedToPay:
            return "Odbio da plati";
        case UserReportReasonType.PaymentIssue:
            return "Problem sa plaćanjem";
        case UserReportReasonType.AbuseOfSystem:
            return "Zloupotreba aplikacije (npr. rezervacije bez namere)";
        case UserReportReasonType.MultipleAccounts:
            return "Više naloga (fake account abuse)";
        case UserReportReasonType.InappropriateBehavior:
            return "Neprimereno ponašanje u lokalu";
        case UserReportReasonType.OffensiveLanguage:
            return "Uvredljiv govor";
        case UserReportReasonType.Harassment:
            return "Uznemiravanje";
        case UserReportReasonType.IncorrectInformation:
            return "Netačni podaci (ime, telefon...)";
        case UserReportReasonType.SuspiciousActivity:
            return "Sumnjivo ponašanje";
        case UserReportReasonType.Other:
            return "Ostalo (uz opis)";
        default:
            return "Nepoznat razlog";
    }
}